import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Paper,
  Tab,
  Tabs
} from '@material-ui/core';

import PurchaseOrdersTable from 'components/PurchaseOrders/PurchaseOrdersTable';
import PurchaseOrderInvoicesTable from 'components/PurchaseOrders/PurchaseOrderInvoicesTable';
import PurchaseOrderDetails from 'components/PurchaseOrders/PurchaseOrderDetails';

import { setNewPODisplayId } from 'redux/actions';

const PurchaseOrderListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const addPurchaseOrder = () => {
    setOpen(true);
    createPODisplayId();
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const createPODisplayId = () => {
    const length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.purchaseOrder;
    let PONum;
    length < 100 ? 
      PONum = new Array(3 + 1 - (length + '').length).join('0') + length
    : PONum = length
    props.setNewPODisplayId("PO-" + PONum);
  };

  return (
    <Box>
      { !open ?
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      > 
        <Button
          color="primary"
          variant="contained"
          onClick={addPurchaseOrder}
        >
          New P.O.
        </Button>
      </Box> : null }
      <Box sx={{ mt: 3 }}>
        { open ?
          <PurchaseOrderDetails
            activeUserId={props.activeUserId}
            products={props.products}
            productCategories={props.productCategories}
            productCompanies={props.productCompanies}
            vendors={props.vendors}
            idGen={props.idGen}
            setOpen={setOpen}
          /> :
          ( <Box>
            <Box sx={{ display: 'flex' }}>
              <Paper>
                <Tabs
                  value={tabValue}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleTabChange}
                  centered
                >
                  <Tab label="Purchase Orders" />
                  <Tab label="Purchase Invoices" />
                </Tabs>
              </Paper>
            </Box>
            <Box>
              { tabValue === 0 ?
              <Box marginTop={1}>
                <PurchaseOrdersTable
                  purchaseOrders={props.purchaseOrders}
                  products={props.products}
                  vendors={props.vendors}
                  user={props.user}
                />
              </Box> : null }
              { tabValue === 1 ?
              <Box marginTop={1}>
                <PurchaseOrderInvoicesTable
                  purchaseOrders={props.purchaseOrders}
                  vendors={props.vendors}
                />
              </Box> : null }
            </Box>
          </Box> )
        }
      </Box>
    </Box>
  )
};

export default connect (null, {setNewPODisplayId}) (PurchaseOrderListResults);